import { render, staticRenderFns } from "./MailingViewTemplateDlg.vue?vue&type=template&id=273586e0&"
import script from "./MailingViewTemplateDlg.vue?vue&type=script&lang=js&"
export * from "./MailingViewTemplateDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports